<template>
    <div>
        <div class="main-content">
            <h2>我的指标
                <span class="detail-btn right" v-show="indicators.length !==0 && detail_data === 0" @click.stop="detail_data = 1">详细数据</span>
                <span class="detail-btn right hide" v-show="indicators.length !==0 && detail_data === 1" @click="detail_data = 0">图表数据</span>
            </h2>
            <div class="b-b m-b-sm"></div>
            <div class="tips" v-if="indicators.length === 0">
                您暂未获得指标数据，请前往
                <router-link to="/evaluate">测评中心</router-link>进行素质测评，生成指标数据。
            </div>
            <div class="row" v-show="indicators.length !== 0 && detail_data === 0">
                <div class="col-xs-12">
                    <div class="row">
                        <div class="col-xs-6 col-sm-3 m-t-b-sm" v-for="indicator in indicators" :key="indicator._id">
                            <div class="indicator">
                                <div class="score">{{indicator.grade_name||(indicator.score.toFixed(2))}}</div>
                                <div class="rate">
                                    领先于
                                    <span class="percent">{{(indicator.rate* 100).toFixed(2)}}%</span>的用户
                                </div>
                                <div class="title">{{indicator.indicator.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-show="indicators.length !== 0&&detail_data === 1">
                <div class="col-xs-12 indicator-detail" v-for="(indicator,index) in indicators" :key="indicator._id">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="label">指标名称：</div>
                            <div class="desc"> {{indicator.indicator.name}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="label">指标得分：</div>
                            <div class="desc"> {{(indicator.score.toFixed(2))}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="label">指标排名：</div>
                            <div class="desc">领先
                                <span class="rate">{{(indicator.rate*100).toFixed(2)}}%</span>的用户</div>
                        </div>
                    </div>
                    <div class="row" v-if="indicator.grade_name">
                        <div class="col-xs-12">
                            <div class="label">指标等级：</div>
                            <div class="desc"> {{indicator.grade_name}}</div>
                        </div>
                    </div>
                    <div class="row" v-if="indicator.grade_desc">
                        <div class="col-xs-12">
                            <div class="label">指标解析：</div>
                        </div>
                        <div class="col-xs-12">
                            <div class="desc n-p-l" v-html="indicator.grade_desc"></div>
                        </div>
                    </div>
                    <div class="b-b b-dashed"></div>
                </div>
            </div>
        </div>
        <div class="main-content m-t-md" v-show="indicators.length >= 3">
            <h2>指标雷达</h2>
            <div class="b-b m-b-sm"></div>
            <div class="row">
                <div class="col-xs-12" id="radar-area" style="width:100%;">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Echarts from 'echarts/lib/echarts.js'
import 'echarts/lib/chart/radar.js'
import 'echarts/lib/component/legend'

import User from '../../resource/user'
export default {
    data: function () {
        return {
            indicators: [],
            echarts: null,
            is_mounted: false,
            detail_data: 0
        }
    },
    computed: {
        ...mapGetters({
            'user': 'loginUser'
        })
    },
    created: function () {
        let that = this
        document.title = `我的指标-个人中心|${that.global.name}`
        if (that.user.category === 2) {
            that.$router.replace('/company')
        } else {
            that.load()
        }
    },
    watch: {
        indicators: function (now) {
            let that = this
            if (that.is_mounted && now.length >= 3) {
                setTimeout(function () { that.buildRadar() }, 300)
            }
        }
    },
    mounted: function () {
        let that = this
        that.is_mounted = true
        if (that.indicators.length >= 3) {
            setTimeout(function () { that.buildRadar() }, 300)
        }
    },
    methods: {
        load: function () {
            let that = this
            User.indicators({}, {}).then(res => {
                let data = res.body
                if (data.code == 0) {
                    that.indicators = data.result
                } else {
                    alert(data.msg)
                }
            }, res => { })
        },
        buildRadar: function () {
            let that = this
            if (!that.echarts) {
                that.echarts = Echarts.init(document.querySelector('#radar-area'))
            }
            let options = {
                legend: {
                    data: ['用户指标'],
                    orient: 'vertical',
                    right: '20px'
                },
                radar: {
                    indicator: []
                },
                series: [{
                    name: '用户指标',
                    type: 'radar',
                    data: [
                        {
                            value: [],
                            name: '用户指标'
                        }
                    ]
                }]
            };
            that.indicators.forEach(function (indicator) {
                options.radar.indicator.push({
                    'name': indicator.indicator.name,
                    'max': indicator.indicator.point_system
                })
                options.series[0].data[0].value.push(indicator.score)
            }, this);
            that.echarts.setOption(options);
        }
    },
    destroyed: function () {
        let that = this
        if (that.echarts) {
            that.echarts.dispose()
            that.echarts = null
        }
    }
}
</script>
<style lang="less" scoped>
.tips {
    padding: 150px 80px;
    font-size: 18px;
    line-height: 1.5;
    text-align: center;
}

#radar-area {
    height: 300px;
}
</style>



// WEBPACK FOOTER //
// indicator.vue?23948e16